// Campus photo for /colleges/samford-university: Public domain, by Sweetmoose6 at English Wikipedia, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASamford_University_Reid_Chapel.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/samford-university/; credited under the photo.
const photo = {
    "slug": "samford-university",
    "alt": "Reid Chapel and its white steeple beside a green lawn at Samford University in Birmingham, Alabama",
    "src": "/colleges/samford-university/campus-1600.webp",
    "srcSmall": "/colleges/samford-university/campus-800.webp",
    "srcMid": "/colleges/samford-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/samford-university/og.jpg",
    "title": "Samford University Reid Chapel",
    "author": "Sweetmoose6 at English Wikipedia",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASamford_University_Reid_Chapel.JPG",
    "read": "2026-10-01"
};

export default photo;
